import React from 'react';

const InfoSection = () => {
  return (
    <section className="info-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: '40px', flexWrap: 'wrap' }}>
        <div className="info-image" style={{ flexShrink: '0' }}>
          <img src="/A.png" alt="Floki Face" />
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
